/*
 errorHandler

 This class handles exceptions in the UI

 */

const bootbox = require('bootbox');

export const errorHandler = {
    //Process the xhr response
    processResponse(xhr) {
        if (xhr.status && xhr.status === 500) {

            var message = "An error occurred";

            if (xhr.responseJSON && xhr.responseJSON.exceptions && xhr.responseJSON.exceptions.length > 0) {
                message = xhr.responseJSON.exceptions[0].message;
            }

            if (message.length > 500) {
                message = message.substring(0, 500);
            }

            errorHandler.show(message);
        }
    },

    /**
     * @param {string} message 
     */
    show(message) {
        bootbox.alert({
            size: 'medium',
            message: message,
            title: 'An Error Has Occurred - ' + new Date().toLocaleDateString() + ' ' + new Date().toLocaleTimeString()
        });
    }
};
